import axios, { AxiosRequestConfig } from "axios";
import { addSagAuthInterceptor } from "@sazka/utils/http-clients/sag-auth-interceptor";

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: "/api/wincheck",
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const httpClient = axios.create(config);

addSagAuthInterceptor(httpClient);

/** Adding the response interceptors */
httpClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        /** Do something with response error */
        return Promise.reject(error);
    }
);

export { httpClient as httpClientWincheck };
